export default __webpack_public_path__ + "static/media/smartMirror1.97728697.jpg";